import { render, staticRenderFns } from "./gaBoard.vue?vue&type=template&id=5c5f9014&"
import script from "./gaBoard.vue?vue&type=script&lang=js&"
export * from "./gaBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports